import { SettingsBase } from "./SettingsBase";

export class EventJsonSettings extends SettingsBase{
    static NAME_OF_CLASS = 'EventJsonSettings';
    public DisableContestantTimes: boolean = false;

    public constructor(args?: {
        DisableContestantTimes: boolean;
    
    }) {
        super();
        this.DisableContestantTimes = args?.DisableContestantTimes ?? false;
    }

    public static Create({
        DisableContestantTimes = false,
    }) {
        return new EventJsonSettings({
            DisableContestantTimes,
        });
    };
}